import Loader from '@sharedComponents/Loader';
import PropTypes from 'prop-types';

import * as style from './style.module.css';

const PageLoading = ({ relative = false, fullscreen = false }) => (
    <div className={`${style.spinnerContainer} ${relative ? style.relativeContainer : ''} ${fullscreen ? style.fullscreen : ''}`}>
        <Loader className={style.spinner} />
    </div>
);

PageLoading.propTypes = {
    relative: PropTypes.bool,
};

export default PageLoading;
